<div class='row'>
  <div class='col-6'>
    <ng-template #rt let-r="result" let-t="name">
      <ngb-highlight [result]="r.Person.LastName + ', ' + r.Person.FirstName + ', ' + r.InsuranceNumber" [term]="t"></ngb-highlight>
    </ng-template>

    <input type="text" class="form-control form-control-sm" [ngbTypeahead]="searchCustomer" [resultTemplate]="rt"
      [formControl] = "control" [inputFormatter]="formatter" (selectItem)="selectCustomer($event)" placeholder="Kundensuche">
    
  </div>
  <div class ='col-2'>
    <span class ="clickable"  (click)="clear()">
      <i class ="fas fa-times"></i>
    </span>
  </div>
</div>
